__turbopack_context__.v({
  "checkboxWrapper": "cAZ1-a_checkboxWrapper",
  "contentWrapper": "cAZ1-a_contentWrapper",
  "emailField": "cAZ1-a_emailField",
  "emailWrapper": "cAZ1-a_emailWrapper",
  "form": "cAZ1-a_form",
  "newsletterConsentWrapper": "cAZ1-a_newsletterConsentWrapper",
  "submitButton": "cAZ1-a_submitButton",
});
